module.exports = __webpack_public_path__ + "static/media/StarChack.0fe29031.svg";